// extracted by mini-css-extract-plugin
export default {"paginado":"Paginado_paginado__t8XmY","cur":"Paginado_cur__un86K","paginado2":"Paginado_paginado2__-SC26","p":"Paginado_p__D2-dO","p1":"Paginado_p1__vTvFX"};